/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DIVIDER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	divider: {
		backgroundColor: '#EEF2F6',
		display: 'block',
		width: '100%',
		height: pxToEm(1),
		margin: '16px auto',

		// ----- sizes ----- //
		'&.size-full': { width: '100%' },
		'&.size-large': { width: '85%' },
		'&.size-medium': { width: '70%' },
		'&.size-small': { width: '50%' },
		'&.size-xsmall': { width: '25%' },

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				background: theme.color[uniqueColor].medium.swatch
			}
		})
	}
});